import type { Middleware } from 'redux'
import { CHECKOUT_ADD_ITEM, CHECKOUT_REMOVE_ITEM, CHECKOUT_UPDATE_ITEM } from 'actions/actionConstants'
import { CLEAR_MERCHANDISE_SHIPPING_QUOTES } from 'actions/apiActionConstants'

/**
 * Middleware to clear merchandise shipping quotes cache when cart items change
 *
 * This ensures shipping costs are re-calculated when:
 * - Items are added to cart
 * - Items are removed from cart
 * - Item quantities change (handled by add/remove of individual items)
 *
 * Free shipping qualification depends on cart totals, so we must re-fetch
 * shipping quotes on every cart mutation.
 */
const merchandiseShippingCacheMiddleware: Middleware<{}, App.State> = (store) => (next) => (action: any) => {
  // Let the action proceed first
  const result = next(action)

  // After the action, check if we need to clear shipping cache
  const cartMutationActions = [
    CHECKOUT_ADD_ITEM,
    CHECKOUT_REMOVE_ITEM,
    CHECKOUT_UPDATE_ITEM,
  ]

  if (cartMutationActions.includes(action.type)) {
    // Cart changed - clear shipping quotes cache to force re-fetch
    store.dispatch({
      type: CLEAR_MERCHANDISE_SHIPPING_QUOTES,
    })
  }

  return result
}

export default merchandiseShippingCacheMiddleware
